import React from 'react';
import { DEFAULT_ERROR_MESSAGE, ModalFormButton } from 'framework/form';
import CreateAgreementForm from 'domain/finance/vendors/createupdate/Create/CreateAgreementForm';
import createAgreementValidationSchema from 'domain/finance/vendors/createupdate/Create/createAgreementValidationSchema';
import { useVendorId } from '../../routes';
import useVendorService from '../../useVendorService';
import { useShowContext } from 'framework/show';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { useListContext } from 'framework/list';
import { VendorAgreementDto } from '../../types';

interface CreateAgreementButtonProps {
  isVisible?: boolean;
}

const CreateAgreementButton = ({ isVisible = true }: CreateAgreementButtonProps) => {
  const vendorId = useVendorId()!;
  const { createAgreement } = useVendorService();
  const { data: vendor } = useShowContext();
  const { addMessage } = useMessageService('modalForm');
  const { reloadData = () => {} } = useListContext();

  const canCreateAgreement =
    vendor?.profileStatus === 'FINALIZED' && vendor?.workingStatus === 'ACTIVE' && vendor?.isCompliant === true;

  const handleSubmit = async (values: Partial<VendorAgreementDto>) => {
    try {
      const result = await createAgreement(vendorId, values);
      return result || {};
    } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : DEFAULT_ERROR_MESSAGE;
      addMessage(new ErrorMessage(errorMessage));
      return false;
    }
  };

  if (!isVisible || !canCreateAgreement) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle="Create agreement"
      submitFormFunc={handleSubmit}
      getValidationSchemaFunc={async () => createAgreementValidationSchema}
      label="Create agreement"
      afterSubmit={{
        execute: () => reloadData(),
      }}
      paperStyles={{ background: 'var(--mui-palette-background-paper)' }}
      sxButton={{ alignSelf: 'flex-end' }}
    >
      <CreateAgreementForm />
    </ModalFormButton>
  );
};

export default CreateAgreementButton;
